/**
 * Monta URL de screen pop CRM a partir do template e dados da chamada.
 * Equivalente ao GetParUrl() + frmWebCRM do PhoenixCliente.
 */
export function buildScreenPopUrl(template, params = {}) {
  if (!template || typeof template !== 'string') return null;

  const {
    phone = '',
    callId = '',
    call_id = '',
    contactName = '',
    name = '',
    cpf = '',
    campaignId = '',
    campaign_id = '',
    agentId = '',
    groupId = '',
    extension = ''
  } = params;

  const values = {
    phone,
    fone: phone,
    call_id: callId || call_id,
    atendimento: callId || call_id,
    assinante: contactName || name,
    nome: contactName || name,
    cpf,
    campaign_id: campaignId || campaign_id,
    campanha: campaignId || campaign_id,
    agent_id: agentId,
    group_id: groupId,
    extension,
    ramal: extension
  };

  let url = template;

  Object.entries(values).forEach(([key, val]) => {
    if (val === undefined || val === null) return;
    const encoded = encodeURIComponent(String(val));
    url = url.replace(new RegExp(`\\{${key}\\}`, 'gi'), encoded);
  });

  const query = new URLSearchParams();
  const add = (k, v) => {
    if (v !== undefined && v !== null && String(v) !== '') query.set(k, String(v));
  };

  add('fone', phone);
  add('phone', phone);
  add('atendimento', callId || call_id);
  add('call_id', callId || call_id);
  add('assinante', contactName || name);
  add('cpf', cpf);
  add('campanha', campaignId || campaign_id);
  add('agent_id', agentId);
  add('group_id', groupId);
  add('ramal', extension);

  if (url.includes('?')) {
    const extra = query.toString();
    return extra ? `${url}&${extra}` : url;
  }

  const qs = query.toString();
  return qs ? `${url}?${qs}` : url;
}
